import { indexData } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-10 text-center font-heading">主题索引</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto">
          {indexData.map((item, i) => (
            <a key={i} href="#topics" className="flex items-start gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200/60 hover:bg-primary-50/40 transition-all duration-200 cursor-pointer no-underline group">
              <div className="w-10 h-10 flex-shrink-0 rounded-lg bg-primary-100/70 flex items-center justify-center group-hover:bg-primary-200/70 transition-colors">
                <i className={`${item.icon} text-lg text-primary-600`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors whitespace-nowrap">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-1 mb-2">{item.desc}</p>
                <span className="text-[10px] text-secondary-600 bg-secondary-100/80 px-2 py-0.5 rounded-full whitespace-nowrap">{item.count}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}